import { Route } from '@angular/router';
import { authGuard, loggedOutGuard, lossRunProcessorGuard } from '@program-suite/data-auth';
import { LoggedInComponent, LoggedOutComponent } from '@program-suite/ui';
import { SubmissionGridComponent } from '@program-suite/feature-submission-grid';
import { PolicyGridComponent } from '@program-suite/feature-policy-grid';
import { ViewSubmissionComponent } from '@program-suite/feature-view-submission';
import { FeaturePolicyFormsGridComponent } from '@program-suite/feature-policy-forms-grid';
import { PendingRequestsComponent } from '@program-suite/feature-pending-requests';
import { StartQuoteComponent } from '@program-suite/feature-start-quote';
import { ProgramDashboardComponent } from '@program-suite/feature-program-dashboard';
import { ProgramGuidelinesComponent, ProgramGuidelinesDetailsComponent } from '@program-suite/feature-program-guidelines';
import { UserProfileComponent } from '@program-suite/feature-user-profile';
import { AdditionalInsuredFormComponent, CoverageAdjustmentFormComponent } from '@program-suite/feature-policy-endorsements';
import { WholesalersGridComponent } from '@program-suite/feature-wholesalers-grid';
import { AgencyGridComponent } from '@program-suite/feature-agencies-grid';
import { FeatureAllUsersComponent } from '@program-suite/feature-all-users';
import { AgencyUsersComponent } from '@program-suite/feature-agency-users';
import { AdminSettingsComponent } from '@program-suite/feature-admin-settings';

export const appRoutes: Route[] = [
  {
    path: 'authentication',
    component: LoggedOutComponent,
    canActivate: [loggedOutGuard],
    children: [
      {
        path: 'login',
        loadComponent: () => import('@program-suite/ui-login').then((m) => m.LoginComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('@program-suite/ui-forgot-password').then((m) => m.ForgotPasswordComponent),
      },
      {
        path: 'reset',
        loadComponent: () => import('@program-suite/ui-reset-password').then((m) => m.ResetPasswordComponent),
      },
    ]
  },
  {
    path: '',
    canActivate: [authGuard()],
    canActivateChild: [lossRunProcessorGuard],
    component: LoggedInComponent,
    children: [
      {
        path: '',
        redirectTo: 'pending-request',
        pathMatch: 'full',
      },
      {
        path: 'quote',
        component: StartQuoteComponent,
      },
      {
        path: 'quote/:id',
        loadComponent: () => import('@program-suite/feature-quoting').then((m) => m.QuoteWizardComponent),
      },
      {
        path: 'dashboard',
        component: ProgramDashboardComponent,
      },
      {
        path: 'submissions',
        component: SubmissionGridComponent,
      },
      {
        path: 'submissions/:tab/:id',
        component: ViewSubmissionComponent,
      },
      {
        path: 'policies',
        component: PolicyGridComponent,
      },
      {
        path: 'policies/:tab/:id',
        component: ViewSubmissionComponent,
      },
      {
        path: 'policies/:tab/:id/additional-insured/:id',
        component: AdditionalInsuredFormComponent,
      },
      {
        path: 'policies/:tab/:id/coverage-adjustment/:id',
        component: CoverageAdjustmentFormComponent,
      },
      {
        path: 'program-guidelines',
        component: ProgramGuidelinesComponent,
      },
      {
        path: 'program-guidelines/:id',
        component: ProgramGuidelinesDetailsComponent,
      },
      {
        path: 'policy-forms',
        component: FeaturePolicyFormsGridComponent,
      },
      {
        path: 'pending-request',
        component: PendingRequestsComponent,
      },
      {
        path: 'pending-request/additional-insured/:id',
        component: AdditionalInsuredFormComponent,
      },
      {
        path: 'pending-request/coverage-adjustment/:id',
        component: CoverageAdjustmentFormComponent,
      },
      {
        path: 'profile',
        component: UserProfileComponent,
      },
      {
        path: 'wholesalers',
        component: WholesalersGridComponent,
      },
      {
        path: 'wholesale-settings',
        component: AdminSettingsComponent,
      },
      {
        path: 'wholesale-settings/:tab',
        component: AdminSettingsComponent,
      },
      {
        path: 'agencies',
        component: AgencyGridComponent,
      },
      {
        path: 'agents',
        component: FeatureAllUsersComponent,
      },
      { 
        path: 'agency',
        component: AgencyUsersComponent,
      },
      {
        path: 'agency/:tab',
        component: AgencyUsersComponent,
      },
    ],
  },
  {
    path: 'login',
    redirectTo: 'authentication/login',
  }
];
